module.exports = __webpack_public_path__ + "static/media/IMG_3562.2017ec5c.jpg";